
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "Paginator",
  filters: {
    truncate(value) {
      if (value && value.split(" ").length > 3) {
        value = value.split(" ");
        return `${value[0]} ${value[1]} ${value[2]}...`;
      }
      return value;
    }
  }
})
export default class SortBox extends Vue {
  @Prop(Object) readonly values!: Object;
  @Prop(Function) readonly onSortChange!: Function;

  preventWatcher: boolean = false;
  sortBox: string = Object.keys(this.values)[0];

  @Watch("sortBox")
  onSortBoxChange(val: string, oldVal: string) {
    if (this.preventWatcher) {
      this.preventWatcher = false;
    } else {
      this.onSortChange(val);
    }
  }

  update(value: any) {
    this.preventWatcher = true;
    this.sortBox = value;
  }
}
